query ZipcodesForCompany($input: ZipcodesForCompanyInput) {
  zipcodesForCompany(input: $input)
}

